import { useEffect } from 'react'
import CustomHead from 'components/common/HeadMeta/HeadMeta'
import Template from 'components/downloads/DownloadApplicationDevelopment'

const Download: React.FC = () => {
  useEffect(() => {
    document.querySelector('body').classList.remove('non-chat')
  }, [])
  return (
    <>
      <CustomHead
        keyword={'アプリ開発 アプリケーション開発 要件定義 予算 ベンダー 資料 ダウンロード ホワイトペーパー'}
        image={'https://aitria.co.jp/images/img/download/application-development/ogp.png'}
        url={'https://aitria.co.jp/download/application-development/'}
        title="アプリ開発 発注前チェックリスト | 資料ダウンロード | Aitria（アイトリア）"
        description="アプリケーション開発の際に、要件定義・予算・ベンダー選定などに活用できる資料です。発注前のチェックリストもあり、迷ったら読むべき資料になっています。"
      />
      <Template />
    </>
  )
}

export default Download
